import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Menu } from '../../../../../asistente-en-linea/models/Menu';
import { MenuService } from '../../menu.service';
import { AuthService } from '../../../../auth/auth.service';
import { AsistenteTipo } from 'src/app/config/config/models/asistente-tipo';
import { AsistenteFormularioService } from '../../../asistente-formulario/asistente-formulario.service';
import { AsistenteChatService } from '../../../asistente-chat/asistente-chat.service';

@Component({
  selector: 'app-delete-menu-dialog',
  templateUrl: './delete-menu-dialog.component.html',
  styleUrls: ['./delete-menu-dialog.component.scss']
})
export class DeleteMenuDialogComponent implements OnInit {
  menus: Menu[];
  ejecutando: boolean;
  finalizado: boolean;
  mensaje: string;
  error: boolean;
  constructor(
    private menuService: MenuService,
    private authService: AuthService,
    public dialogRef: MatDialogRef<DeleteMenuDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Menu,
    private chatService: AsistenteChatService,
    private formularioService: AsistenteFormularioService) {
    this.ejecutando = false;
    this.finalizado = false;
    this.error = false;
  }

  ngOnInit() {
  }
  cancelar(): void {
    this.dialogRef.close(false);
  }

  aceptar(): void {
    this.dialogRef.close(true);
  }


  deleteMenu() {
    this.ejecutando = true;
    this.finalizado = false;
    this.error = false;
    if (this.data.id) {
      const idMenu = this.data.id;
      if (this.data.tipo == AsistenteTipo.Menu) {
        this.eliminarMenu(idMenu);
      }
      else if (this.data.tipo == AsistenteTipo.Chat) {
        this.eliminarChat(idMenu);
      }
      else if (this.data.tipo == AsistenteTipo.Formulario) {
        this.eliminarFormulario(idMenu);
      }
      else {
        this.eliminarMenu(idMenu);
      }
    }
  }

  eliminarMenu(idMenu) {
    this.menuService.deleteMenu(idMenu, this.authService.getUser().username).subscribe((response: any) => {
      if (response && (response.statusCode == 200 || response.statusCode == 0)) {
        this.finalizado = true;
      } else {
        this.mensaje = response.statusMessage || "Ocurrió un error al eliminar el asistente menú.";
        this.error = true;
        this.ejecutando = false;
      }
    },
      error => {
        this.mensaje = error;
        this.error = true;
        this.ejecutando = false;
      })
  }

  eliminarChat(idMenu) {
    this.chatService.delete(idMenu, this.authService.getUser().username).subscribe((response: any) => {
      if (response && (response.statusCode == 200 || response.statusCode == 0)) {
        this.finalizado = true;
      } else {
        this.mensaje = response.statusMessage || "Ocurrió un error al eliminar el asistente chat.";
        this.error = true;
        this.ejecutando = false;
      }
    },
      error => {
        this.mensaje = error;
        this.error = true;
        this.ejecutando = false;
      })
  }

  eliminarFormulario(idMenu) {
    this.formularioService.delete(idMenu, this.authService.getUser().username).subscribe((response: any) => {
      if (response && ((response.statusCode == 200 || response.statusCode == 0))) {
        this.finalizado = true;
      } else {
        this.mensaje = response.statusMessage || "Ocurrió un error al eliminar el asistente formulario.";
        this.error = true;
        this.ejecutando = false;
      }
    },
      error => {
        this.mensaje = error;
        this.error = true;
        this.ejecutando = false;
      })
  }

}